<mat-form-field [floatLabel]="floatLabel" class="lims-dropdown" appearance="outline" #singleSelect [ngClass]="class">
    <mat-label *ngIf="label">
        {{ label }}
        <span *ngIf="required" class="required">*</span>
    </mat-label>
    <mat-select [(value)]="value" (selectionChange)="selectionChange($event)" placeholder="{{ placeholder }}" [disabled]="disabled" [formControl]="formControl" [multiple]="multiple" (focusout)="onFocusOut($event)">
      <mat-option>
            <ngx-mat-select-search [formControl]="selectFilterCtrl" [placeholderLabel]="placeholder"
                [noEntriesFoundLabel]="noEntriesFoundLabel"></ngx-mat-select-search>
        </mat-option>
        <mat-option value="null" *ngIf="allItemLabel" (click)="changeValue()" [disabled]="disableAllItem">{{ allItemLabel }}</mat-option>
        <mat-option *ngFor="let select of filteredselects | async" [value]="select[keyId]" (click)="changeValue(select[keyId])" [disabled]="flagDisable && select.isDisable">
            {{ select[keyName] }}
        </mat-option>
    </mat-select>
    <mat-error *ngIf="error" [innerHtml]="error"></mat-error>
</mat-form-field>